import { Box } from "@aircall/tractor";

import { TranscriptionItemUtteranceEntryProps } from "./TranscriptionItemUtteranceEntry.decl";
import * as S from "./TranscriptionItemUtteranceEntry.styled";

export function TranscriptionItemUtteranceEntry({
  w,
  startTime,
  active,
  currentTime,
  matched,
}: TranscriptionItemUtteranceEntryProps) {
  return (
    <S.Entry
      startTime={startTime}
      currentTime={currentTime}
      active={active}
      variant={active || matched ? "bodyMediumM" : "bodyRegularM"}
    >
      <Box
        as="span"
        backgroundColor={matched ? "warning-300" : undefined}
        data-highlighted={matched ? true : undefined}
      >
        {w}
      </Box>
      {` `}
    </S.Entry>
  );
}
